import { QueryExtraOptions } from '@reduxjs/toolkit/dist/query/endpointDefinitions';
import type { BaseQueryFn } from '@reduxjs/toolkit/query';
import type { AxiosRequestConfig, AxiosError, AxiosResponse } from 'axios';

import { IPaginationResponse } from '@/interfaces/pagination';
import { API_V4_BASE_URL } from '@/settings';

import { request } from './api';

type Params = AxiosRequestConfig & { formatResponse?: (response: AxiosResponse | any) => any };

export const axiosBaseQuery =
  (
    baseConfigs: { baseURL: string; method: string } = { baseURL: API_V4_BASE_URL, method: 'get' }
  ): BaseQueryFn<Params, unknown, unknown> =>
  async ({ url, method, data, params, baseURL, formatResponse }) => {
    try {
      const configs = {
        method: method || baseConfigs.method,
        baseURL: baseURL || baseConfigs.baseURL
      };
      const result = await request({ ...configs, url, data, params });

      if (formatResponse) {
        return { data: formatResponse(result) };
      }

      return result;
    } catch (axiosError) {
      const err = axiosError as AxiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message
        }
      };
    }
  };

export const paginationConfig: Pick<
  QueryExtraOptions<any, IPaginationResponse | any, object, any>,
  'forceRefetch' | 'serializeQueryArgs' | 'merge'
> = {
  forceRefetch({ currentArg, previousArg }) {
    return JSON.stringify(currentArg) !== JSON.stringify(previousArg);
  },
  serializeQueryArgs: ({ endpointName }) => {
    return endpointName;
  },
  merge: (currCache, newCache) => {
    currCache.total_rows = newCache.total_rows;
    currCache.total_pages = newCache.total_pages;
    currCache.page = newCache.page;
    currCache.links = newCache.links;

    if (newCache.page.page === 1) {
      currCache.data = newCache.data;
    } else {
      currCache.data.push(...newCache.data);
    }
  }
};
